(function ($, undefined) {
    // recaptcha-solved
    jQuery.validator.addMethod("recaptchasolved", function (value, element) {
        return $(element).closest("form").find("textarea[name='g-recaptcha-response']").val() !== "";
    });

    jQuery.validator.unobtrusive.adapters.add("recaptchasolved", function (options) {
        options.rules["recaptchasolved"] = options.params;
        if (options.message) {
            options.messages["recaptchasolved"] = options.message;
        }
    });
}(jQuery));
$(document).ready(function () {
    var sitekey = $('.g-recaptcha').data('sitekey');
    grecaptcha.ready(function () {
        grecaptcha.execute(sitekey, { action: 'submit' })
            .then(function (token) {
                window.onSubmitContact;
            });
    });

    window.onSubmitContact = function () {

        const form = document.getElementById("formContact");
        const data = {};
        const elements = form.elements;
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            const name = element.name;
            const value = element.value;
            data[name] = value;
        }
        const options = {
            method: 'POST'
        };
        const xhr = new XMLHttpRequest();
        xhr.open('POST', '/umbraco/surface/ContactForm/submit/', true);
        xhr.onload = function () {
            if (xhr.status === 200) { // Check for successful response
                showEnquiryResponse(xhr, null);
            } else {
                showEnquiryResponse(xhr, null);
            }
        };
        xhr.onerror = function (error) {
            showEnquiryResponse(xhr, null);
        };
        const formData = new FormData(form);
        xhr.send(formData);
    }
    window.showEnquiryResponse = function (jsonResponse, statusText) {

        var response = JSON.parse(jsonResponse.responseText);

        if (response.Success === true) {
            const form = document.getElementById("formContact");
            form.querySelectorAll("input").forEach(input => input.value = ""); // Clear form inputs
            form.style.display = "none"; // Hide the form
            document.getElementById("enquiry-thankyou").style.display = "block"; // Show thank you message
        } else {

            const enquiryError = document.getElementById("enquiryError");
            enquiryError.innerHTML = `<p>${response.Message}</p>`;
            enquiryError.style.display = "block"; // Show error message
        }
    }

});
